export default __webpack_public_path__ + "static/media/crumple.8faeba10.mp3";